import React from 'react';
import { Home, BarChart3, Database, AlertTriangle, Settings, ChevronRight } from 'lucide-react';

interface SidebarProps {
  activeItem: string;
  onItemClick: (item: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeItem, onItemClick }) => {

  const menuItems = [
    { id: 'overview', label: 'Overview', icon: Home },
    { id: 'metrics', label: 'Metrics', icon: BarChart3 },
    { id: 'database', label: 'Database', icon: Database },
    { id: 'alerts', label: 'Alerts', icon: AlertTriangle },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  return (
    <aside className="dashboard-sidebar">
      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              className={`sidebar-item ${activeItem === item.id ? 'active' : ''}`}
              onClick={() => onItemClick(item.id)}
            >
              <Icon size={18} />
              <span>{item.label}</span>
              <ChevronRight size={14} className="sidebar-chevron" />
            </button>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="connection-status">
          <div className="status-indicator connected"></div>
          <span>Connected to data source</span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
